import { CommonModule, NgOptimizedImage } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { UiComponentsModule } from '@finxone-platform/ui-components';
import {
  WorkflowFinxDropdownComponent,
  WorkflowFinxSwitchComponent,
} from '@finxone-platform/ui-components/workflow';
import { SortablejsModule } from '@maksim_m/ngx-sortablejs';
import { CodeEditorModule } from '@ngstack/code-editor';
import { ColorPickerDirective } from 'ngx-color-picker';
import { NgxSmartModalModule, NgxSmartModalService } from 'ngx-smart-modal';
import { ConfirmationService } from 'primeng/api';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DragDropModule } from 'primeng/dragdrop';
import { ToastModule } from 'primeng/toast';
import { CodeEditorPopupComponent } from './code-editor-popup/code-editor-popup.component';
import { ColorPickerVariablesComponent } from './color-picker-variables/color-picker-variables.component';
import { CommonActionHeaderComponent } from './common-action-header/common-action-header.component';
import { FormWidgetPopupComponent } from './form-widget-popup/form-widget-popup.component';
import { HeaderComponent } from './header/header.component';
import { IconLibraryComponent } from './icon-library/icon-library.component';
import { ImageUploadDirectiveDirective } from './image-upload-popup/directive/image-upload-directive.directive';
import { IconUploadPopupComponent } from './image-upload-popup/icon-upload-popup/icon-upload-popup.component';
import { ImageUploadPopupComponent } from './image-upload-popup/image-upload-popup.component';
import { LeftMenusComponent } from './left-menus/left-menus.component';
import { PasswordStrengthComponent } from './password-strength/password-strength.component';
import { SideNavbarComponent } from './side-navbar/side-navbar.component';
@NgModule({
  declarations: [
    LeftMenusComponent,
    HeaderComponent,
    SideNavbarComponent,
    ImageUploadPopupComponent,
    IconUploadPopupComponent,
    PasswordStrengthComponent,
    CommonActionHeaderComponent,
    IconLibraryComponent,
    CodeEditorPopupComponent,
    ColorPickerVariablesComponent,
    FormWidgetPopupComponent,
  ],
  imports: [
    ImageUploadDirectiveDirective,
    CodeEditorModule,
    CommonModule,
    ConfirmDialogModule,
    ToastModule,
    FormsModule,
    MatIconModule,
    NgxSmartModalModule.forRoot(),
    UiComponentsModule,
    ReactiveFormsModule.withConfig({
      warnOnNgModelWithFormControl: 'never',
    }),
    SortablejsModule,
    DragDropModule,
    ColorPickerDirective,

    // standalone components
    WorkflowFinxDropdownComponent,
    WorkflowFinxSwitchComponent,
    NgOptimizedImage,
    AutoCompleteModule,
  ],
  exports: [
    ImageUploadDirectiveDirective,
    LeftMenusComponent,
    HeaderComponent,
    SideNavbarComponent,
    ImageUploadPopupComponent,
    PasswordStrengthComponent,
    CommonActionHeaderComponent,
    IconLibraryComponent,
    CodeEditorPopupComponent,
    ColorPickerVariablesComponent,
    FormWidgetPopupComponent,
  ],
  providers: [ConfirmationService, NgxSmartModalService],
})
export class SharedModule {}
